export default "__VITE_ASSET__arz1kBoW__"